export type ReceiptENT = {
  id: number;
  user_id: number;
  name_recipient: string;
  address_recipient: string;
  postalCode_recipient: string;
  city_recipient: string;
  siret_recipient: string;
  tva_recipient: string | null;
  plan_id: number;
  plan_name: string;
  valid_until: Date;
  NAF_code: string;
  additional_NAF: string;
  total_HT: number;
  total_TTC: number;
  created_at: Date;
};

export type ReceiptPUB = {
  id: number;
  user_id: number;
  consultation_id: number;
  name_recipient: string;
  address_recipient: string;
  postalCode_recipient: string;
  city_recipient: string;
  siret_recipient: string;
  tva_recipient: string | null;
  total_HT: number;
  total_TTC: number;
  created_at: Date;
};

export enum PaymentTypes {
  CB = 'CB',
  Chèque = 'Chèque',
  Virement = 'Virement'
}
